// removed by extract-text-webpack-plugin
module.exports = {"search":"search__3gZpiDWzlf35 filter__27z2EcKF8ebq"};